import React from 'react';

import { Glyph } from './MoreGlyph.styles';

/**
 * Side-menu "More" trigger glyph — a 3×3 grid of dots (the overflow / "apps"
 * affordance from the Owner Studio design). Drawn inline with
 * `fill="currentColor"` so the trigger button recolours it by setting `color`
 * (rest → side-menu tone, open/hover → the nav accent), the same way the wallet
 * glyph beside it recolours.
 */
export type MoreGlyphProps = {
  size?: number;
  className?: string;
};

const DOTS = [5, 12, 19];

export const MoreGlyph = ({ size = 24, className }: MoreGlyphProps): React.ReactElement => (
  <Glyph className={className} aria-hidden="true">
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {DOTS.map((cy) =>
        DOTS.map((cx) => <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={1.7} fill="currentColor" />),
      )}
    </svg>
  </Glyph>
);

export default MoreGlyph;
